// Editorial moment page renderer — pulls moment data from cas-moments.json,
// resolves picks via CAS_PRODUCT_MAP (built server-side), and renders the page.
(function() {
  const SLUG = window.CAS_PAGE_HANDLE;
  const MOMENTS_URL = window.CAS_MOMENTS_URL;
  const PRODUCTS_URL = window.CAS_PRODUCTS_URL;

  if (!SLUG || !MOMENTS_URL) return;

  Promise.all([
    fetch(MOMENTS_URL).then(r => r.json()),
    PRODUCTS_URL ? fetch(PRODUCTS_URL).then(r => r.json()).catch(() => ({})) : Promise.resolve({}),
  ]).then(([momentsData, productMap]) => {
    const moments = momentsData.moments || [];
    const PRODUCTS = productMap || {};
    renderMoment(moments, PRODUCTS);
  });

  function renderMoment(moments, PRODUCTS) {
    const moment = (moments || []).find(m => m.slug === SLUG);
    if (!moment) {
      const t = document.getElementById('hero-title');
      if (t) t.textContent = 'Moment not found';
      return;
    }

    document.title = `${moment.title} — Chicago Award Source`;

    // Hero
    document.getElementById('hero-bg').style.backgroundImage = `url('${assetUrl(moment.hero_image)}')`;
    document.getElementById('hero-corner-text').textContent = `§ ${moment.number} · ${moment.kicker}`;
    document.getElementById('hero-title').textContent = moment.title;
    document.getElementById('hero-sub').textContent = moment.subtitle;

    // Stats
    const stats = moment.stats || [];
    document.getElementById('intro-side-meta').innerHTML = stats.map(s => `
      <div class="stat">
        <div class="stat-fig">${s.fig}</div>
        <div class="stat-label">${s.label}</div>
        <div class="stat-source">— ${s.source}</div>
      </div>
    `).join('');

    // Body intro
    document.getElementById('intro-body').innerHTML =
      moment.intro.map(p => `<p>${p}</p>`).join('');

    // Trusted-by logos
    const LOGOS = [
      { name: "Chicago Cubs",     src: "cubs.png", mark: true },
      { name: "Chicago Fire FC",  src: "chicago-fire.png", mark: true },
      { name: "Nike",             src: "nike.svg", mark: true },
      { name: "McDonald's",       src: "mcdonalds.svg", mark: true },
      { name: "BCG",              src: "bcg.png", whiten: true },
      { name: "United",           src: "united.png", whiten: true },
      { name: "Deloitte",         src: "deloitte.png", whiten: true },
    ];
    const trustedEl = document.getElementById('trusted-logos');
    if (trustedEl) {
      trustedEl.innerHTML = LOGOS.map(l =>
        `<div class="trusted-logo${l.mark ? ' is-mark' : ''}" title="${l.name}">
           <img src="${assetUrl(l.src)}" alt="${l.name}"${l.whiten ? ' style="filter: brightness(0) invert(1);"' : ''}>
         </div>`
      ).join('');
    }

    // Picks grid
    document.getElementById('curator-intro').textContent = moment.curator_intro || '';
    const picksGrid = document.getElementById('picks-grid');
    picksGrid.innerHTML = moment.picks.map(pick => {
      const p = PRODUCTS[pick.sku];
      if (!p) return `
        <div class="pick-card">
          <div class="pick-img-wrap">
            <span class="pick-tier-badge">${pick.tier}</span>
          </div>
          <div class="pick-info">
            <div class="pick-name">${pick.sku}</div>
            <div class="pick-curator">${pick.note}</div>
          </div>
        </div>`;
      return `
        <a href="${p.url}" class="pick-card">
          <div class="pick-img-wrap">
            <span class="pick-tier-badge">${pick.tier}</span>
            <img src="${p.image}" alt="${p.title}" loading="lazy">
          </div>
          <div class="pick-info">
            <div class="pick-name">${p.title}</div>
            <div class="pick-meta">
              <span>SKU·CAS.${pick.sku}</span>
              <span class="price">$${p.price}</span>
            </div>
            <div class="pick-curator">${pick.note}</div>
            <span class="pick-cta">View piece →</span>
          </div>
        </a>`;
    }).join('');

    // Program lineup (optional)
    if (moment.program_lineup) {
      const pl = moment.program_lineup;
      document.getElementById('program-section').style.display = 'block';
      document.getElementById('program-title').textContent = pl.title;
      document.getElementById('program-sub').textContent = pl.subtitle;
      document.getElementById('program-body').innerHTML = pl.tiers.map(t => `
        <div class="program-tier">
          <div class="program-tier-head">
            <div class="program-tier-label">${t.tier}</div>
            <div class="program-tier-sub">${t.subtitle || ''}</div>
          </div>
          <div class="program-awards">
            ${t.awards.map(a => {
              const p = PRODUCTS[a.sku];
              if (!p) return `
                <div class="program-award">
                  <div class="program-award-img"></div>
                  <div class="program-award-info">
                    <div class="program-award-name">${a.name}</div>
                    <div class="program-award-sku"><span>SKU·CAS.${a.sku}</span></div>
                    <div class="program-award-note">${a.note}</div>
                  </div>
                </div>`;
              return `
                <a href="${p.url}" class="program-award">
                  <div class="program-award-img"><img src="${p.image}" alt="${p.title}" loading="lazy"></div>
                  <div class="program-award-info">
                    <div class="program-award-name">${a.name}</div>
                    <div class="program-award-sku"><span>SKU·CAS.${a.sku}</span><span class="price">$${p.price}</span></div>
                    <div class="program-award-note">${a.note}</div>
                  </div>
                </a>`;
            }).join('')}
          </div>
        </div>
      `).join('');
    }

    // Set callout
    if (moment.set_callout) {
      const sc = moment.set_callout;
      document.getElementById('set-section').style.display = 'grid';
      document.getElementById('set-title').textContent = sc.title;
      document.getElementById('set-blurb').textContent = sc.blurb;
      document.getElementById('set-bundle-note').textContent = sc.bundle_note || '';
      document.getElementById('set-images').innerHTML =
        sc.skus.map(sku => {
          const p = PRODUCTS[sku];
          return p
            ? `<div class="mom-set-img"><img src="${p.image}" alt="${p.title}"></div>`
            : `<div class="mom-set-img"></div>`;
        }).join('');
    }

    // Bulk tiers
    document.getElementById('bulk-grid').innerHTML = (moment.bulk_tiers || []).map(t => {
      const isQuote = (t.discount || '').toLowerCase().includes('quote');
      return `
        <div class="bulk-tier${isQuote ? ' quote' : ''}">
          <div class="qty">${t.qty}</div>
          <div class="discount">${t.discount}</div>
          <div class="note">${t.note}</div>
        </div>`;
    }).join('');
  }

  // Resolve a filename to a Shopify CDN asset URL using a known asset URL pattern
  function assetUrl(filename) {
    if (!filename) return '';
    if (filename.startsWith('http') || filename.startsWith('//')) return filename;
    // Strip any "/assets/" prefix from filename if present
    const f = filename.replace(/^\/?(assets\/)?(instagram\/)?/, '');
    // Use the moments.json URL's prefix to build asset URL
    if (window.CAS_MOMENTS_URL) {
      return window.CAS_MOMENTS_URL.replace(/cas-moments\.json.*$/, f);
    }
    return f;
  }
})();
